// In page jumpLink
var JumpLink = {

	selector: 'a:not(.footnote-link, .list-nav__link, .list-nav-secondary__link, .anchor-links-link)',
	contentNav: '.nav-chapters',

	init: function () {

		if (!$(this.selector).length) return;

		this.bindClickEvent();
	},

	bindClickEvent: function () {

		$(JumpLink.selector).on('click', function (event) {

			var headerHeight = $('.global-header').height(),
				thisHash = this.hash;

			if (!$(thisHash).length) return;

			// Prevent default anchor click behavior
			event.preventDefault();

			if (thisHash !== "") {

				// set focus
				$(thisHash).attr('tabindex', '-1');
				setTimeout(function () {
					$(thisHash).trigger('focus');
				}, 100);

				// Jump to link with smooth animation
				if ($(JumpLink.contentNav).length) {
					// get height from line bar and top nav
					var lineBarHeight = $('.nav-chapters__line').height(),
						contentNavHeight = $(JumpLink.contentNav).height(),
						navHeight = lineBarHeight + contentNavHeight + 2;

					if ($(window).width() < 1023) {

						$('html, body').animate({
							scrollTop: $(thisHash).offset().top - navHeight
						}, 800);

					} else {
						$('html, body').animate({
							scrollTop: $(thisHash).offset().top - (headerHeight + lineBarHeight + 5)
						}, 800);

					}
				} else {
					if ($(window).width() < 1023) {

						$('html, body').animate({
							scrollTop: $(thisHash).offset().top - 5
						}, 800);

					} else {
						$('html, body').animate({
							scrollTop: $(thisHash).offset().top - (headerHeight + 5)

						}, 800);
					}
				}
			}

		});
	}
};

$(document).ready(function () {
	JumpLink.init();
}); 